//import React from 'react';
import React, { Component,useState,useRef,useEffect } from 'react'
import { Cell, Grid } from 'react-md'
// import { replaceImageWidth, createVideoLinkIframe } from '../../common/functions'

//CSS Import
// import '../../css/AnswerTypeRadiobutton.css'
import MathJax from '../../../../../components/react-mathjax-preview'
import LoadingSpinner from '../../../../../components/LoadingSpinner'
import MathParserUtil from '../../../../../lib/math-parser'
import { replaceImageWidth, createVideoLinkIframe } from '../../../../../common/functions'
import VectorParserUtil from '../../../../../lib/vector-math-parser'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'

import Canvas from "../../../../../components/vectors/canvas";
import SFVectorAnswer from "./SFVectorAnswer"
const checkBoxOneColumnSize = 1;
const checkBoxValueOneColumnSize = 11;

const checkBoxTwoColumnSize = 1;
const checkBoxValueTwoColumnSize = 5;

const SFMCRadioTypeAnswers = function (props) {

    const [localValue, setLocalValue] = useState("");

    useEffect(() => {
        if (props.selectedAnswers) {
            setLocalValue(props.selectedAnswers);
        }
    }, [props.selectedAnswers])

    console.debug("props.displayAnswerArr", props)

    let handleClickContent = function (index) {
        if (event.target.closest(".view-vectors-container")) {
            return; // return if clicked within the '.view-vectors-container' 
        }
        let radioElement = document.getElementById('radio' + index);
        if (radioElement !== undefined && radioElement !== null)
            radioElement.click();
    }
    let handleClick = function (id, index) {

        if (props.onAnswerChoice !== undefined)
            props.onAnswerChoice(id, index);
    }

    let checkBoxSizeDesktop;
    let checkBoxValueSizeDesktop;

    if (props.numOfColumns === 2) {
        checkBoxSizeDesktop = checkBoxTwoColumnSize;
        checkBoxValueSizeDesktop = checkBoxValueTwoColumnSize;
    } else {
        checkBoxSizeDesktop = checkBoxOneColumnSize;
        checkBoxValueSizeDesktop = checkBoxValueOneColumnSize;
    }

    let answerDisplayArray = [];
    let selectedAnswer = props.selectedAnswers;
    if (props.displayAnswerArr !== undefined &&
        props.displayAnswerArr !== null &&
        props.displayAnswerArr !== "") {

        if (props.currentQuestionType === 0) {
            console.debug("props.displayAnswerArr--------", props.displayAnswerArr, props?.currentAnswerType)
        }
        answerDisplayArray = props.displayAnswerArr.map((answerArr, cIndex) => {
            if (answerArr.answer_text !== undefined && answerArr.answer_text !== null && answerArr.answer_text !== "" && props?.currentAnswerType !== 70) {
                let checkBox =
                    <Radio
                        size='small'
                        className='p-0 mr-2'
                        name='AnswerTypeRadio'
                        id={'radio' + cIndex}
                        // hidden={!props.compact}
                        hidden
                       /*  onClick={(e) => {
                            e.preventDefault();
                            handleClick(answerArr.answer_id.toString(), cIndex)
                        }} */
                        type='radio' value={answerArr.answer_id.toString()}
                        checked={localValue === answerArr.answer_id.toString() ? true : false} />
                    ;
                if (answerArr.isChecked === true || localValue === answerArr.answer_id.toString()) {
                    checkBox =
                        <Radio
                            size='small'
                            className='p-0 mr-2'
                            id={'radio' + cIndex}
                            // hidden={!props.compact}
                            hidden
                            name='AnswerTypeRadio' checked
                            /* onClick={(e) => {
                                e.preventDefault();
                                handleClick(answerArr.answer_id.toString(), cIndex)
                            }} */
                            type='radio'
                            value={answerArr.answer_id.toString()}
                        />

                }
                var ansTxt = answerArr.answer_text.toString('html', null).replace("<p><br></p>", "").replace("<p><br></p>", "")
                if (props.currentQuestionType === 1) {
                    ansTxt = MathParserUtil.computeFormula(ansTxt, props.currentVariableMap, answerArr.answer_display_options);
                }
                if (props.currentQuestionType === 3 && props.answerType === 50) {
                    console.debug("props.currentVectorVariableMap", props.currentVectorVariableMap)
                    ansTxt = MathParserUtil.computeFormula(ansTxt, props.currentVectorVariableMap, answerArr.answer_display_options);
                }
                ansTxt = replaceImageWidth(props, ansTxt)

                let content = React.createElement(MathJax, { "math": ansTxt });

                return <Cell key={cIndex + 'Radio'}
                    // onClick={() => handleClickContent(cIndex)}
                    className={`w-full h-full ${props.compact ? 'sf-ans-btn-parent' : ''}`}
                    size={checkBoxValueSizeDesktop}>
                    <div 
                    onClick={(e) => {
                        e.preventDefault();
                        // handleClickContent(cIndex)
                        setLocalValue(answerArr.answer_id.toString())
                        handleClick(answerArr.answer_id.toString(), cIndex)
                    }}
                    className={`
                            sf-ans-btn cursor-pointer 
                            ${(localValue === answerArr.answer_id.toString()) ? "sf-ans-btn-selected " : " "}

                            ${props.showAnswerResponse && !props.showSubmitLoader && selectedAnswer === answerArr.answer_id.toString() ? (props.answerCorrect ? "sf-ans-btn-correct " : "sf-ans-btn-incorrect ") : " "}

                            ${props.showAnswerResponse && !props.showSubmitLoader && answerArr.isChecked ? "sf-ans-btn-correct " : " "}
                        `}>
                        {checkBox}
                        <label className='cursor-pointer p-0 m-0 w-100' htmlFor={'radio' + cIndex}>{content}{ansTxt !== null ? createVideoLinkIframe(ansTxt) : ''}</label>
                    </div>

                </Cell>
                    ;
            }else if(props.currentQuestionType === 0 && answerArr?.vectorAnswerVariable && answerArr?.vectorAnswerVariable.length > 0 && props?.currentAnswerType === 70) {
                let checkBox =
                <Radio
                    name='AnswerTypeRadio'
                    id={'radio' + cIndex}
                    hidden
                    // onChange={() => handleClick(answerArr.answer_id.toString(), cIndex)}
                    type='radio' value={answerArr.answer_id.toString()}
                    checked={localValue === answerArr.answer_id.toString() ? true : false} />
                ;
                if (answerArr.isChecked === true) {
                    checkBox =
                        <Radio
                            id={'radio' + cIndex}
                            hidden
                            name='AnswerTypeRadio' checked
                            // onChange={() => handleClick(answerArr.answer_id.toString(), cIndex)}
                            type='radio'
                            value={answerArr.answer_id.toString()}
                        />

                }
                
                const vectorVariableMap = VectorParserUtil.buildQuestionVariablesMap(answerArr?.vectorAnswerVariable);
                const vectorSettingsData = props?.vectorSettingsData;
                const newVectorValues = vectorVariableMap 
                    ? vectorVariableMap.getVectorsArray(
                        vectorSettingsData?.enableIdenticalVector,
                        vectorSettingsData
                      ).filter(value => value !== undefined)
                    : [];
                return <Cell key={cIndex + 'Radio'}
                // onClick={() => handleClickContent(cIndex)}
                className={`w-full h-full ${props.compact ? 'sf-ans-btn-parent' : ''}`}
                size={checkBoxValueSizeDesktop}>
                <div 
                onClick={(e) => {
                    if (e.target.closest(".view-vectors-container")) {
                        return; // return if clicked within the '.view-vectors-container' 
                    }
                    e.preventDefault();
                    setLocalValue(answerArr.answer_id.toString())
                    handleClick(answerArr.answer_id.toString(), cIndex)
                }}
                className={`
                        sf-ans-btn cursor-pointer 
                        ${(localValue === answerArr.answer_id.toString()) ? "sf-ans-btn-selected " : " "}

                        ${props.showAnswerResponse && !props.showSubmitLoader && localValue === answerArr.answer_id.toString() ? (props.answerCorrect ? "sf-ans-btn-correct " : "sf-ans-btn-incorrect ") : " "}

                        ${props.showAnswerResponse && !props.showSubmitLoader && answerArr.isChecked ? "sf-ans-btn-correct " : " "}
                    `}>
                    {checkBox}
                    <label className='cursor-pointer p-0 m-0 w-100' htmlFor={'radio' + cIndex}>

                        {
                         answerArr?.newVectorValues !== undefined && answerArr?.newVectorValues && answerArr?.newVectorValues.length > 0  && vectorSettingsData ? 

                            <SFVectorAnswer
                                vector={[...answerArr?.newVectorValues]}
                                vectorSettingsData={vectorSettingsData}
                              /> : ""
                               
                        }
                    </label>
                </div>

            </Cell>
            }
        }
        );

    }

    if (props.displayAnswerArr !== undefined && props.displayAnswerArr.length > 0)
        return <div>
            <div className='mb-2'>Select one from the below options:
            </div>
            <Grid>
                {answerDisplayArray}
            </Grid>
        </div>
    else
        return <LoadingSpinner />


}

export default SFMCRadioTypeAnswers;
